var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 11989",
    transform: "translate(8 8)",
    fill: "#5e708d",
    stroke: "#707070",
    d: "M0 0h18v18H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 329",
    transform: "translate(-8 -8)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 11988",
    fill: "none",
    d: "M8 8h18v18H8z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 24982",
    fill: "#5e708d",
    transform: "translate(13.25 11)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4021",
    cx: 1.5,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4022",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0 4.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4023",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0 9)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4024",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(4.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4025",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(4.5 4.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4026",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(4.5 9)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/Drag_Icon.080c17aff4e18462f11394e7214cb025.svg";
export { ForwardRef as ReactComponent };